import { render } from "./Sellers.vue?vue&type=template&id=c47a2706&scoped=true"
import script from "./Sellers.vue?vue&type=script&lang=js"
export * from "./Sellers.vue?vue&type=script&lang=js"

import "./Sellers.vue?vue&type=style&index=0&id=c47a2706&lang=scss&scoped=true"
import "./Sellers.vue?vue&type=style&index=1&id=c47a2706&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c47a2706"]])

export default __exports__